export default __webpack_public_path__ + "static/media/logo-bouddha.ff309820.svg";